import { RefreshCw } from "lucide-react";
import type React from "react";
import { Button } from "./ui/button";
import {
	Dialog,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
} from "./ui/dialog";

interface SyncConfirmModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const SyncConfirmModal: React.FC<SyncConfirmModalProps> = ({
	isOpen,
	onClose,
	onConfirm,
}) => {
	return (
		<Dialog open={isOpen} onOpenChange={(v) => !v && onClose()}>
			<DialogContent className="max-w-[460px]">
				<DialogHeader>
					<div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-(--color-primary) to-[#8b5cf6] text-white">
						<RefreshCw size={32} />
					</div>
					<DialogTitle className="text-center">
						Sync Users from Cognito
					</DialogTitle>
				</DialogHeader>
				<DialogDescription className="text-center">
					This will reconcile all Cognito users against the portal database.
				</DialogDescription>
				<ul className="list-disc space-y-1 pl-5 text-(--color-foreground) text-sm">
					<li>New Cognito users will be created in the database</li>
					<li>Changed attributes (email, name, status) will be updated</li>
					<li>Admin-set roles are never overwritten</li>
					<li>
						Users removed from Cognito will be flagged inactive (not deleted)
					</li>
				</ul>
				<DialogFooter>
					<Button variant="outline" onClick={onClose}>
						Cancel
					</Button>
					<Button
						onClick={() => {
							onConfirm();
							onClose();
						}}
					>
						<RefreshCw size={16} />
						Run Sync
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default SyncConfirmModal;
